// src/pages/Gallery.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const YELLOW = '#FFED29';
const BLACK = '#1a1a1a';
const WHITE = '#ffffff';

export default function Gallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('all');

  // Properly categorized images based on actual content
  const categories = {
    'Werkstatt Innen': [
      
      { src: '/3 (8).jpg', alt: 'Werkzeuge & Geräte' },
    ],
    'Außenbereich': [
      
      { src: '/3 (13).jpg', alt: 'Außenbereich' },
      { src: '/3 (14).jpg', alt: 'Außenbereich' },
      { src: '/3 (11).jpg', alt: 'Werkzeuge & Geräte' },
      { src: '/3 (12).jpg', alt: 'Werkzeuge & Geräte' },
    ],
    'Werkzeuge & Geräte': [
      
      
      { src: '/3 (17).jpg', alt: 'Werkzeuge & Geräte' },
      
      { src: '/3 (3).jpg', alt: 'Werkzeuge & Geräte' },
      { src: '/3 (15).jpg', alt: 'Außenbereich' },
   
      { src: '/3 (6).jpg', alt: 'Werkstatt Innen' },
    
      { src: '/3 (9).jpg', alt: 'Werkstatt Innen' },
      { src: '/3 (10).jpg', alt: 'Werkstatt Innen' },
      { src: '/3 (18).jpg', alt: 'Werkstatt Innen' },
    ],
  };

  // Flatten all images for lightbox
  const allImages = Object.values(categories).flat();

  // Get filtered images based on selected category
  const getFilteredImages = () => {
    if (selectedCategory === 'all') {
      return allImages;
    }
    return categories[selectedCategory] || [];
  };

  const filteredImages = getFilteredImages();

  const openLightbox = (index) => {
    setCurrentImage(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
  };

  const goToNext = () => {
    setCurrentImage((prev) => (prev + 1) % filteredImages.length);
  };

  const goToPrev = () => {
    setCurrentImage((prev) => (prev - 1 + filteredImages.length) % filteredImages.length);
  };

  const handleKeyDown = (e) => {
    if (!lightboxOpen) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') goToNext();
    if (e.key === 'ArrowLeft') goToPrev();
  };

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, filteredImages.length]);

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        
        .gallery-page {
          min-height: 100vh;
          background: ${BLACK};
          padding: 100px 20px 60px;
        }

        .gallery-header {
          max-width: 1400px;
          margin: 0 auto 40px;
          text-align: center;
        }

        .gallery-title {
          font-size: clamp(2rem, 5vw, 3.5rem);
          font-weight: 900;
          color: ${WHITE};
          margin-bottom: 16px;
          letter-spacing: -1px;
        }

        .gallery-subtitle {
          font-size: 1.1rem;
          color: rgba(255, 255, 255, 0.7);
          max-width: 600px;
          margin: 0 auto 30px;
          line-height: 1.6;
        }

        .back-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: ${YELLOW};
          text-decoration: none;
          font-weight: 600;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          padding: 10px 20px;
          border: 2px solid ${YELLOW};
          border-radius: 6px;
        }

        .back-link:hover {
          background: ${YELLOW};
          color: ${BLACK};
          transform: translateX(-4px);
        }

        /* Category Filters */
        .category-filters {
          max-width: 1400px;
          margin: 0 auto 40px;
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          justify-content: center;
        }

        .category-btn {
          padding: 12px 24px;
          background: transparent;
          color: ${WHITE};
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 8px;
          font-size: 0.95rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .category-btn:hover {
          border-color: ${YELLOW};
          color: ${YELLOW};
        }

        .category-btn.active {
          background: ${YELLOW};
          color: ${BLACK};
          border-color: ${YELLOW};
        }

        .gallery-grid {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 20px;
        }

        @media (max-width: 640px) {
          .gallery-grid {
            grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
            gap: 12px;
          }
          
          .category-filters {
            gap: 8px;
          }
          
          .category-btn {
            padding: 10px 16px;
            font-size: 0.85rem;
          }
        }

        .gallery-item {
          position: relative;
          aspect-ratio: 1;
          overflow: hidden;
          border-radius: 12px;
          cursor: pointer;
          background: #2d2d2d;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .gallery-item:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(255, 237, 41, 0.3);
        }

        .gallery-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.4s ease;
          /* Remove shine effect */
          filter: none;
          -webkit-filter: none;
        }

        .gallery-item:hover img {
          transform: scale(1.08);
        }

        /* Lightbox */
        .lightbox {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.95);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          animation: fadeIn 0.3s ease forwards;
        }

        @keyframes fadeIn {
          to { opacity: 1; }
        }

        .lightbox-content {
          position: relative;
          max-width: 90vw;
          max-height: 90vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .lightbox-image {
          max-width: 100%;
          max-height: 90vh;
          object-fit: contain;
          border-radius: 8px;
          /* Remove shine effect from lightbox images */
          filter: none;
          -webkit-filter: none;
        }

        .lightbox-close {
          position: fixed;
          top: 30px;
          right: 30px;
          width: 50px;
          height: 50px;
          border: none;
          background: ${YELLOW};
          color: ${BLACK};
          font-size: 28px;
          font-weight: bold;
          cursor: pointer;
          border-radius: 50%;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          /* Remove any default button shine */
          box-shadow: none;
          -webkit-appearance: none;
        }

        .lightbox-close:hover {
          transform: rotate(90deg) scale(1.1);
          background: #FFE600;
        }

        .lightbox-nav {
          position: fixed;
          top: 50%;
          transform: translateY(-50%);
          width: 60px;
          height: 60px;
          border: none;
          background: ${YELLOW};
          color: ${BLACK};
          font-size: 28px;
          font-weight: bold;
          cursor: pointer;
          border-radius: 50%;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          /* Remove any default button shine */
          box-shadow: none;
          -webkit-appearance: none;
        }

        .lightbox-nav:hover {
          background: #FFE600;
          transform: translateY(-50%) scale(1.1);
        }

        .lightbox-nav.prev {
          left: 30px;
        }

        .lightbox-nav.next {
          right: 30px;
        }

        .lightbox-counter {
          position: fixed;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
          background: ${YELLOW};
          color: ${BLACK};
          padding: 12px 24px;
          border-radius: 30px;
          font-weight: 700;
          font-size: 1rem;
          z-index: 10000;
          box-shadow: none;
        }

        @media (max-width: 768px) {
          .lightbox-nav {
            width: 50px;
            height: 50px;
            font-size: 24px;
          }
          
          .lightbox-nav.prev {
            left: 15px;
          }
          
          .lightbox-nav.next {
            right: 15px;
          }
          
          .lightbox-close {
            top: 15px;
            right: 15px;
            width: 45px;
            height: 45px;
          }
          
          .lightbox-counter {
            bottom: 15px;
            padding: 10px 20px;
            font-size: 0.9rem;
          }
        }

        .fade-in {
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Stagger animation for grid items */
        ${filteredImages.map((_, i) => `
          .gallery-item:nth-child(${i + 1}) {
            animation-delay: ${i * 0.03}s;
          }
        `).join('')}
      `}</style>

      <div className="gallery-page">
        {/* Header */}
        <div className="gallery-header">
          <h1 className="gallery-title">
            Unsere <span style={{ color: YELLOW }}>Galerie</span>
          </h1>
          <p className="gallery-subtitle">
            Entdecke unsere moderne Werkstatt, professionelle Ausstattung und erfolgreich abgeschlossene Projekte.
          </p>
          <Link to="/" className="back-link">
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Zurück zur Startseite
          </Link>
        </div>

        {/* Category Filters */}
        <div className="category-filters">
          <button
            className={`category-btn ${selectedCategory === 'all' ? 'active' : ''}`}
            onClick={() => setSelectedCategory('all')}
          >
            Alle Bilder ({allImages.length})
          </button>
          {Object.keys(categories).map((category) => (
            <button
              key={category}
              className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category} ({categories[category].length})
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {filteredImages.map((img, index) => (
            <div
              key={index}
              className="gallery-item fade-in"
              onClick={() => openLightbox(index)}
            >
              <img src={img.src} alt={img.alt} loading="lazy" />
            </div>
          ))}
        </div>

        {/* Lightbox */}
        {lightboxOpen && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <img
                src={filteredImages[currentImage].src}
                alt={filteredImages[currentImage].alt}
                className="lightbox-image"
              />
            </div>

            <button className="lightbox-close" onClick={closeLightbox} aria-label="Schließen">
              ×
            </button>

            <button className="lightbox-nav prev" onClick={goToPrev} aria-label="Vorheriges Bild">
              ‹
            </button>

            <button className="lightbox-nav next" onClick={goToNext} aria-label="Nächstes Bild">
              ›
            </button>

            <div className="lightbox-counter">
              {currentImage + 1} / {filteredImages.length}
            </div>
          </div>
        )}
      </div>
    </>
  );
}